import React, { forwardRef } from "react";
import CommonInput from "@/shared/components/ui/Input/CommonInput";
import CommonTextArea from "@/shared/components/ui/Input/CommonTextArea";
import CustomSelect from "@/shared/components/ui/Select/CustomSelect";

const FormFields = forwardRef(
  (
    {
      label,
      onChange,
      defaultValue,
      value,
      showRightIcon,
      showRightIconCondition,
      placeholder = "Enter here",
      type = "text",
      rightIcon,
      variant = "input",
      rows,
      disabled,
      editable = true,
      options,
      name,
      ...rest
    },
    ref,
  ) => {
    const getSelectedKeys = () => {
      if (variant === "select") {
        const selectedValue = value !== undefined ? value : defaultValue;
        if (selectedValue) {
          return new Set([selectedValue]);
        }
        return undefined;
      }
      return undefined;
    };

    return (
      <div className="flex flex-col gap-1 w-full">
        <label className="text-[12.5px] font-medium text-gray-800 dark:text-gray-200">
          {label}
        </label>
        {variant === "input" ? (
          <CommonInput
            ref={ref}
            defaultValue={defaultValue}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            showRightIcon={showRightIcon}
            showRightIconCondition={showRightIconCondition}
            type={type}
            rightIcon={rightIcon}
            disabled={disabled}
            editable={editable}
            name={name}
            {...rest}
          />
        ) : variant === "select" ? (
          <CustomSelect
            options={options || []}
            placeholder={placeholder}
            onSelectionChange={onChange}
            triggerClassName="text-[12.5px] font-normal text-gray-800 dark:text-gray-100 dark:!bg-gray-900 border-gray-300 dark:border-gray-800"
            valueClassName="text-[12.5px] font-normal text-gray-800 dark:text-gray-100"
            selectItemClassName="!bg-white dark:!bg-gray-900 !text-[12.5px] !font-normal !text-gray-800 dark:!text-gray-100 hover:!bg-[#207C9733] data-[hover=true]:!bg-[#207C9733] data-[hover=true]:!text-secondary"
            selectedKeys={getSelectedKeys()}
          />
        ) : (
          <CommonTextArea
            defaultValue={defaultValue}
            placeholder={placeholder}
            onChange={onChange}
            rows={rows}
            disabled={disabled}
          />
        )}
      </div>
    );
  },
);

export default FormFields;
